import { Controller } from "@hotwired/stimulus"
import { helpMatches } from "../lib/help_search"

const AUTO_OPEN_MAX = 2

// /help search: filters the FAQ as the user types (question + answer text). Browse sections step aside while a query
// is active, empty groups hide, one or two hits open themselves, and the result count is announced.
export default class extends Controller {
  static targets = ["input", "item", "group", "empty", "status", "browse"]

  connect() {
    this.texts = new Map(this.itemTargets.map((item) => [item, item.textContent]))
  }

  filter() {
    const query = this.inputTarget.value
    const active = query.trim() !== ""
    const hits = this.itemTargets.filter((item) => {
      const hit = helpMatches(this.texts.get(item), query)
      item.hidden = !hit
      // Only close what the search opened; answers the user opened by hand stay open.
      if (item.dataset.searchOpened && (!active || !hit)) {
        item.open = false
        delete item.dataset.searchOpened
      }
      return hit
    })

    this.groupTargets.forEach((group) => {
      group.hidden = !group.querySelector("[data-help-search-target='item']:not([hidden])")
    })
    if (active && hits.length <= AUTO_OPEN_MAX) {
      hits.filter((item) => !item.open).forEach((item) => {
        item.open = true
        item.dataset.searchOpened = "true"
      })
    }

    if (this.hasBrowseTarget) this.browseTarget.hidden = active
    this.emptyTarget.hidden = !active || hits.length > 0
    this.statusTarget.textContent = active ? this.statusTarget.dataset.template.replace("__COUNT__", hits.length) : ""
  }
}
